"use client";
import { useEffect, useState } from "react";
import PropTypes from "prop-types";

import { getListings } from "services/listingService";
import { allListingsParams } from "src/components/listing-map/map/constants";

import { selectedFilterElements } from "@/src/utils/filter-utils";

import TopSide from "components/map/top-side";
import Content from "components/map/content";

const MapScreen = ({ categoryTree, listingCountItems, pathname, newListings, filters }) => {
  const [isLoadingListing, setIsLoadingListing] = useState(false);
  const [newSearchResults, setNewSearchResults] = useState({ ...newListings });

  const { searchCriteria, name, url } = newListings || {};
  const isLandPage = searchCriteria?.category?.category?.slug === "arsa";
  const isSelectedFilterEmpty = !selectedFilterElements(searchCriteria)?.length;
  const isProjectPage = pathname?.includes("/projeler") || false;
  const dataForSaveSearch = {
    name,
    url,
  };

  const getTotalListingLength = () => {
    /* const isAllListingProject = newSearchResults?.allListings?.every((listing) => listing.type === "project");
    const onlyListingLength = newSearchResults?.allListings?.filter((listing) => listing.type === "listing")?.length;
    if (!isProjectPage && isAllListingProject) {
      return 0;
    } else if (!isProjectPage && !isAllListingProject) {
      return onlyListingLength;
    } */
    return newSearchResults.total;
  };

  const handleOrderDropdownChangeWithHistoryPush = async (newUrl) => {
    getAllListings(newUrl, {
      ...allListingsParams,
      ...(isProjectPage
        ? { isProjectSearch: true, isListingSearch: false }
        : { isProjectSearch: false, isListingSearch: true }),
    });
  };

  const getAllListings = async (incomingUrl, incomingParams) => {
    try {
      setIsLoadingListing(true);
      const params = incomingParams || {
        ...allListingsParams,
        ...(isProjectPage
          ? { isProjectSearch: true, isListingSearch: false }
          : { isProjectSearch: false, isListingSearch: true }),
      };
      const url = incomingUrl || pathname;

      const { selectionResponse } = await getListings({ url, params });
      setNewSearchResults(selectionResponse);
      return selectionResponse;
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoadingListing(false);
    }
  };

  useEffect(() => {
    getAllListings();
  }, [pathname]);

  return (
    <>
      <div id="content-wrapper">
        <TopSide
          listingData={dataForSaveSearch}
          totalListing={getTotalListingLength()}
          searchCriteria={newSearchResults?.searchCriteria}
          searchName={newSearchResults?.name}
        />
        <Content
          categoryTree={categoryTree}
          listingCountItems={listingCountItems}
          isLandPage={isLandPage}
          screenType="map"
          isSelectedFilterEmpty={isSelectedFilterEmpty && !newSearchResults?.searchCriteria?.location}
          handleOrderDropdownChangeWithHistoryPush={handleOrderDropdownChangeWithHistoryPush}
          isLoadingListing={isLoadingListing}
          isProjectPage={isProjectPage}
          newSearchResults={newSearchResults}
          getAllListings={getAllListings}
          filters={filters}
          totalListingLength={getTotalListingLength}
        />
      </div>
    </>
  );
};

MapScreen.propTypes = {
  categoryTree: PropTypes.array,
  listingCountItems: PropTypes.array,
  pathname: PropTypes.string,
  newListings: PropTypes.object,
  filters: PropTypes.object,
};

export default MapScreen;
